import { useRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { cn } from "@volca/ui/lib/utils";

interface RosterCellValueProps {
  value: string;
  className?: string;
}

const isClipped = (element: HTMLElement | null) =>
  !!element &&
  (element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth);

export const RosterCellValue = ({ value, className }: RosterCellValueProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      open={open}
      onOpenChange={(next) => setOpen(next && isClipped(ref.current))}
    >
      <TooltipTrigger
        render={
          <span
            ref={ref}
            className={cn(
              "line-clamp-2 max-w-full min-w-0 wrap-anywhere whitespace-normal",
              className,
            )}
          />
        }
      >
        {value}
      </TooltipTrigger>
      <TooltipContent className="wrap-anywhere whitespace-normal">
        {value}
      </TooltipContent>
    </Tooltip>
  );
};
